var $ = require('jquery');

$('.js-search-results__load-all').on('click', function (e) {
	try {
		e.preventDefault();
		$(this).closest('.search-results').find('.search-results__grid-item--is-hidden').removeClass('search-results__grid-item--is-hidden');
		$(this).hide();
	}
	catch(error){
		console.log('Error with the load all button.')
		console.log(error);
	}

})

$('.js-search-header__filter-link').on('click', function(e){
	try {
		e.preventDefault();
		var link_type = $(this).data('linkType');
		// console.log('link_type = ' + link_type);
		var target_section = document.getElementById(link_type);

		if( link_type === 'all' ){
			$('.search-results__section').show();

		} else if( target_section ){
			$('.search-results__section').hide();
			$(target_section).show(225);
		}

		$('.search-header__filter-link').removeClass('search-header__filter-link--is-active');
		$(this).addClass('search-header__filter-link--is-active');

	}
	catch(error){
		console.log('Error with the filter link.')
		console.log(error);
	}

});
